"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkmark = function Checkmark(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M5.477 8.495L4 9.845l3.948 4.322 6.596-8.983L12.932 4 7.78 11.017z" })
  );
};

exports.default = Checkmark;
Checkmark.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Checkmark"
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Checkmark.js
// module id = 617
// module chunks = 0